import React, { Component } from 'react';
import Result from './Result';
import Sidebar from './Sidebar';
import ViewMore from './ViewMore';

class SearchResults extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maxResults: 5
    };
  }

  render() {
    const { results, searchString } = this.props;

    return (
      <div className="results-outer-container">
        <div className="results-inner-container">
          <Sidebar results={results} />
          {results.length > 0  &&
            <div className="main-results">
              <ViewMore
                className="main-results-header-container"
                searchString={searchString}
              />
              {results.slice(0, this.state.maxResults).map((result, i) => (
                <Result key={i} result={result} />
              ))}
              <ViewMore
                className="main-results-footer-container"
                searchString={searchString}
              />
            </div>
           }
        </div>
      </div>
    );
  }
}

export default SearchResults;



// WEBPACK FOOTER //
// ./src/SearchResults.js